import Styled from 'vue3-styled-components';

const TableStyleWrapper = Styled.div`
  padding: 25px;
  background: #fff;
  border-radius: 10px
  table{
    tbody{
      td{
        .user-info{
          .user-name{
            font-size: 14px;
          }
        }
        span.status-text{
          font-size: 12px;
          padding: 0 12.41px;
          line-height: 1.9;
          font-weight: 500;
          border-radius: 12px;
          text-transform: capitalize;
          display: inline-block !important;
          background: #ddd;
          &.active{
            background-color: ${({ theme }) => theme['success-color']}15;
            color: ${({ theme }) => theme['success-color']};
          }
          &.deactivate{
            background-color: ${({ theme }) => theme['warning-color']}15;
            color: ${({ theme }) => theme['warning-color']};
          }
          &.blocked{
            background-color: ${({ theme }) => theme['danger-color']}15;
            color: ${({ theme }) => theme['danger-color']};
          }
        }
      }
    }
    .table-actions{
      min-width: 150px !important;
    }
  }
  .ant-table-pagination.ant-pagination{
    width: 100%;
    text-align: ${({ theme }) => (!theme.rtl ? 'right' : 'left')};
    border-top: 1px solid ${({ theme }) => theme['border-color-light']};
    margin-top: 0 !important;
    padding-top: 30px;
    @media only screen and (max-width: 767px){
      text-align: center;
    }
  }
  .contact-table{
    table{
      tr{
        th{
          &:first-child{
            ${({ theme }) => (theme.rtl ? 'padding-right' : 'padding-left')}: 20px;
          }
          &:last-child{
            ${({ theme }) => (theme.rtl ? 'padding-left' : 'padding-right')}: 20px;
          }
        }
      }
      .table-actions{
        button{
          width: auto;
          height: auto;
          padding: 0;
          background-color: transparent;
          &:hover{
            background-color: transparent;
          }
          &.ant-btn-primary{
            &:hover{
              color: #ADB4D2;
            }
          }
        }
      }
      tbody >tr.ant-table-row-selected >td{
        background-color: ${({ theme }) => theme['primary-color']}10;
      }
    }
  }
`;

const ReportFilterWrapper = Styled.div`
  .products-search-filter {
    padding: 0px 30px 20px;
    
    .sub-form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
  
      span {
        min-width: 80px;
      }
    }
  
    .ant-row {
      margin-bottom: 10px;
      padding: 0;
    }
  
    .ant-col {
      &.ant-form-item-control-wrapper {
        margin-bottom: 20px;
      }
    }
  
    .ant-select {
      margin-left: 0;

      &-multiple {
        .ant-select-selector {
          align-items: normal;
        }
      }

      &-selector {
        height: 34px !important;
        width: 100% !important;
      }
  
      &-selection-item {
        line-height: 23px !important;
        height: 23px !important;
      }
  
      &-selection-search-input {
        height: 34px !important;
      }
    }
  
    .ant-input {
      padding: 5px 11px;
    }
  }
`;

export { TableStyleWrapper, ReportFilterWrapper };
